export default "__VITE_ASSET__DwIDFNqF__"